<template>
  <!-- Possible win and stake -->
  <div>
    <span class="event-title">{{$t('round')}}: {{ticket.EventNumber}}</span>
    <div class="single-event--row">
      <p>
        <span>{{ticket.HomeTeam}}</span> : <span>{{ticket.AwayTeam}}</span>
      </p>
      <span class="value-field" :class="{'hide': isActiveTicket}">
        {{ticket.HomeTeamGoals}}:{{ticket.AwayTeamGoals}}
      </span>
    </div>
    <div class="single-event--row">
      <p>
        {{$t('betType')}}:
        <span class="value-field">{{ticket.TipGroup}}</span>
      </p>
      <span class="value-field">{{format(ticket.TipFactor)}}</span>
    </div>
  </div>
</template>

<script>
import LanguageHelper from '@/mixins/LanguageHelper'
import NumberFormat from '@/mixins/NumberFormat'
export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    ticket: {
      type: Object,
      required: true
    },
    isActiveTicket: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    }
  }
}
</script>
